import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from './button.js';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, } from './dialog.js';
/**
 * Shared shell for the bulk "pick one thing, apply to N conversations" dialogs
 * (template/schedule/pipeline/status). Owns the Dialog/DialogContent wiring,
 * the busy-close guard, and the Cancel button; callers supply the picker body
 * as `children` and the primary action(s) as `footer`.
 *
 * Собран на стандартной анатомии кита (`DialogHeader` / `DialogBody` /
 * `DialogFooter`) — при `size="page"` шапка и подвал перестают ездить, а
 * прокрутку забирает тело, без единой строчки на стороне вызывающего.
 */
export function PickerDialog({ open, onOpenChange, busy = false, onReset, title, description, children, footer, cancelLabel = 'Отмена', size = 'md', contentClassName = 'flex max-w-md flex-col', maxHeight, footerClassName = 'mt-2 flex justify-end gap-2', }) {
    return (_jsx(Dialog, { open: open, onOpenChange: (o) => {
            if (!o && busy)
                return;
            if (!o)
                onReset?.();
            onOpenChange(o);
        }, children: _jsxs(DialogContent, { size: size, className: contentClassName, ...(maxHeight !== undefined ? { maxHeight } : {}), children: [_jsxs(DialogHeader, { className: "gap-4", children: [_jsx(DialogTitle, { children: title }), _jsx(DialogDescription, { children: description })] }), _jsx(DialogBody, { children: children }), _jsxs(DialogFooter, { className: footerClassName, children: [_jsx(Button, { type: "button", variant: "ghost", onClick: () => {
                                onReset?.();
                                onOpenChange(false);
                            }, disabled: busy, children: cancelLabel }), footer] })] }) }));
}
//# sourceMappingURL=picker-dialog.js.map